export default "//cloud.imgsmail.ru/cloud.mail.ru/188971/img/build/empty-state/feed_image.png";